import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import MyBet from "../../casinoComponents/myBet";
import BetTableTeen1 from "../../casinoComponents/betTableTeen1";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import Teen1CardsOverlay from "../../casinoComponents/videoBox/overlays/Teen1CardsOverlay";
import ViewMoreModal from "../../../components/ViewMoreModal";
import ResultTeen1 from "../resultui/resultTeen1/ResultTeen1";
import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/teen1.css";

const GAME_TYPE = "teen1";
// Reference game-header title (lastresults2 res1.cname)
const TITLE = "1 CARD ONE-DAY";

export default function Teen1() {
  const [gameData, setGameData] = useState(null);
  const [iframeSrc, setiframesrc] = useState("");
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    const name = extractCasinoGame(pathname);
    setiframesrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(GAME_TYPE);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const gameDataInterval = setInterval(fetchGameData, 1500);
    return () => clearInterval(gameDataInterval);
  }, [pathname]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          // Convert array to object keyed by team_name
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          // Map bets data to format needed for MyBet component
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null, // Include type field for background color
            selection: bet.selection || bet.player_name || "",
            exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0
          }));
          setMyBets(formattedBets);
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [gameData?.data?.data?.mid]);

  // Fetch exposure on mount and periodically
  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    const intervalId = setInterval(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure, fetchMyBetsData]);

  // Admin panel places no bets: an odds click just refreshes book + My Bets
  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const feed = gameData?.data?.data ?? {};
  const roundId = feed?.mid;
  const resultData = gameData?.lrs ?? feed?.lrs ?? [];

  return (
    <CasinoTableLayout
      tableClass="teen1oneday"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading
          name={TITLE}
          roundId={roundId || ""}
          placedBetCount={myBets.length}
          activeTab="game"
          onTabChange={() => {}}
        />

        <VideoBox
          iframeSrc={iframeSrc}
          timerValue={feed?.lt}
          gameType={GAME_TYPE}
          cardsOverlay={feed?.card != null ? <Teen1CardsOverlay card={feed.card} /> : null}
        />

        {/* Reference renders .casino-detail once the feed has a round (casinoData.mid) */}
        {roundId ? (
          <div className="casino-detail">
            <BetTableTeen1
              data={feed?.sub || []}
              onBetClick={handleBetClick}
              exposures={exposures}
              remark={feed?.remark}
            />{" "}
            <CasinoLastResult
              gameType={GAME_TYPE}
              data={resultData}
              gameData={gameData}
              viewAllLink={`/admin/reports/casinoresult/${GAME_TYPE}`}
              resultComponent={<ResultTeen1 gameType={GAME_TYPE} data={resultData} />}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={GAME_TYPE}
      />
    </CasinoTableLayout>
  );
}
